export default "__VITE_ASSET__RuBmcw2s__"